import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { deleteProductStatus } from '../constants/delete-products-status.constant';
import { dictionaryInformation } from '../constants/dictionary-information.constant';

export const checkProducts = (statusNumber, products, reverseTotal) => {
	if (deleteProductStatus[Enviroment.LANGUAGE][statusNumber] && products.length > 0 && reverseTotal === undefined) {
		return (
			<>
				<h4>{dictionaryInformation[Enviroment.LANGUAGE].stock}</h4>
				<p>Si algunos de los productos no se encuentra en stock en la farmacia, marca el producto y procesa la devolución desde acá:</p>
			</>
		);
	}
};
